<template>
  <div
    class="w-full h-full flex flex-col bg-white border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-300 relative overflow-hidden group rounded-2xl"
  >
    <!-- Card Link Overlay -->
    <NuxtLink v-if="link" :to="link" class="absolute inset-0 z-30" :aria-label="title"></NuxtLink>

    <!-- Image -->
    <div v-if="media" class="w-full relative shrink-0">
      <div class="w-full h-full relative bg-gray-50">
        <AtomsImage
          class="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105 aspect-[4/3]"
          :media="media"
          sizeHint="third"
          :alt="imageAlt"
        />
      </div>
    </div>

    <!-- Text Content -->
    <div class="flex flex-col flex-1 p-6 lg:p-8 bg-white relative z-20 pointer-events-none gap-1 lg:gap-2">
      
      <!-- Title -->
      <h3
        v-if="title"
        class="w-full font-bold text-black text-xl md:text-[22px] leading-snug line-clamp-2"
        v-html="title"
      ></h3>

      <!-- Description -->
      <p
        v-if="description"
        class="w-full mt-1 text-[14.5px] lg:text-[16px] leading-relaxed text-gray-500 line-clamp-3"
        v-html="description"
      ></p>

      <!-- Footer action & Date -->
      <div class="mt-auto pt-6 md:pt-8 flex items-center justify-between w-full pointer-events-auto">
        <!-- Date -->
        <span v-if="date" class="text-[12px] uppercase tracking-widest text-gray-400 font-medium">
          {{ date }}
        </span>

        <!-- Sleek Link Button -->
        <span
          v-if="link"
          class="flex items-center gap-1.5 text-[13px] font-bold text-black uppercase tracking-wider transition-colors group-hover:text-brand-first"
        >
          {{ $t('Detail') }}
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="w-4 h-4 transition-transform duration-300 -translate-x-1 group-hover:translate-x-1">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useLocalePath } from "#i18n";

const props = defineProps({
  category: { type: String },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  date: { type: String },
  link: { type: String, default: null },
  media: {
    type: Object,
  },
  type: { type: String },
  mediaSize: { type: String },
});

import { computed } from 'vue';
import { useSiteSettingsStore } from "@/store/index";
const siteSettingsStore = useSiteSettingsStore();
const containerClass = computed(() => ({
  'flex-col': props.type === 'type_1',
  'flex-col lg:flex-row': props.type === 'type_2',
}));
const imageAlt = computed(() => props.media?.alternativeText ?? props.title ?? props.media?.hash ?? props.media?.name);
const localePath = useLocalePath();
import { getAspectClass } from "~/composables/utils";
</script>
